// 新聞參考來源
import { useState } from 'react';
import Image from 'next/image';

const NewsReference = ({ reference, t }) => {
    // 展開
    const [showReference, setShowReference] = useState(false);

    return (
        <div
            className={`text-btn1 text-black rounded-[2px] border-1 border-dashed border-black2 [&>*]:px-[24px] group
        ${showReference ? 'max-h-[unset]' : 'max-h-[58px]'} overflow-hidden`}
        >
            <div
                onClick={() => setShowReference(!showReference)}
                className="cp py-[10px] flex between-center gap-x-[12px] text-jblack text-bd2b"
            >
                <div className="flex items-center gap-x-[12px] flex-shrink-0 trans group-hover:translate-x-[5px]">
                    <Image
                        className="dark:filter-white"
                        width={20}
                        height={20}
                        src="/images/icon/icon_reference.svg"
                        alt="icon"
                    />
                    <p>{t('REF')}</p>
                </div>

                <div className="flex items-center gap-x-[7px] flex-shrink-0 text-jblack text-bd4n trans group-hover:translate-x-[-5px]">
                    <span className={`${showReference ? 'rotate-[45deg]' : ''}`}>+</span>
                    <p>{t(showReference ? 'CLOSE' : 'UNFOLD')}</p>
                </div>
            </div>

            <div className="text-bd4n text-black8 opacity-[.95] mb-[15px]">
                <p className="leading-[180%] border-t-1 border-dashed border-black2 pt-[10px]">
                    {t('REFERENCE_INTRO')}
                </p>
            </div>

            <div>
                {reference?.map((ref, i) => (
                    //參考來源
                    <a
                        key={'reference' + ref?.link + i}
                        href={ref?.link}
                        target="_blank"
                        className="mb-[30px] space-y-[10px] block opacity-[.95] trans hover:opacity-[.7]"
                        rel="noreferrer noopener"
                    >
                        <p className="text-bd4b text-black">{ref?.name}</p>
                        {ref?.title && (
                            <p className="text-bd4n text-black8 underline">{ref?.title}</p>
                        )}
                    </a>
                ))}
            </div>
        </div>
    );
};

export default NewsReference;
